import config from '../config.json';

export const PHONE_NUMBERS_MASKS = {
    fr: '(.) . .. .. .. ..',
    gf: '(.) ... .. .. ..',
    gp: '(.) ... .. .. ..',
    mq: '(.) ... .. .. ..',
    re: '(.) ... .. .. ..',
    mc: '(.) .. .. .. ..',
    be: '(.) . ... .. ..',
    ch: '(.) .. ... .. ..',
};

export const SERVICES_LEVEL_0 = [
    { label: 'Achats', value: 'achats' },
    { label: 'Administratif', value: 'administratif' },
    { label: 'Commercial', value: 'commercial' },
    { label: 'Communication', value: 'communication' },
    { label: 'Conseil - Audit', value: 'conseil_audit' },
    { label: 'Direction générale', value: 'direction_generale' },
    { label: 'Documentation', value: 'documentation' },
    { label: 'Environnement - HSE', value: 'environnement_hse' },
    { label: 'Finances - Comptabilité', value: 'finances_comptabilite' },
    { label: 'Informatique - Internet - Réseaux', value: 'info_reseaux_internet' },
    { label: 'Juridique', value: 'droit_juridique_justice' },
    { label: 'Logistique', value: 'logisitique' },
    { label: 'Marketing', value: 'marketing' },
    { label: 'Production - Maintenance', value: 'production_maintenance' },
    { label: 'RH - Gestion du personnel', value: 'rh_formation' },
    { label: 'Santé Sécurité au travail', value: 'sst' },
    { label: 'Services généraux', value: 'services_generaux' },
    { label: 'Autre service', value: 'NR' },
];

export const SERVICES_LEVEL_1: { [key: string]: any[] } = {
    achats: [
        { label: 'Responsable des achats', value: 'dir_resp_achats' },
        { label: 'Acheteur(euse)', value: 'acheteur' },
        { label: 'Assistant(e) achats', value: 'assistant_achats' },
        { label: 'Responsable des services économiques', value: 'dir_resp_services_eco' },
        { label: 'Responsable des marchés publics', value: 'resp-marches_publics' },
        { label: 'Autre fonction', value: 'NR' },
    ],
    administratif: [
        { label: 'Responsable administratif', value: 'dir_resp_administratif' },
        { label: 'Assistant(e) administratif', value: 'assistant_administratif' },
        { label: 'Adjoint(e) administratif', value: 'adjoint_administratif' },
        { label: 'Autre fonction', value: 'NR' },
    ],
    direction_generale: [
        { label: 'PDG, Président(e), Vice-président(e) ', value: 'pdg' },
        { label: 'Directeur(trice)', value: 'dir' },
        { label: 'Adjoint(e) de direction', value: 'dir_adjoint' },
        { label: 'Gérant(e) - co-gérant(e) ', value: 'gerant' },
        { label: 'Secrétaire - assistant(e) de direction', value: 'secretaire_assistant_dir' },
        { label: 'Secrétaire Général(e) ', value: 'secretaire_general' },
        { label: 'Autre fonction', value: 'NR' },
    ],
    droit_juridique_justice: [
        { label: 'Responsable juridique', value: 'dir_resp_juridique' },
        { label: 'Adjoint(e) aux affaires juridiques', value: 'adjoint_aff_juridiques' },
        { label: 'Responsable des affaires réglementaires', value: 'dir_resp_aff_reglement' },
        { label: 'Avocat(e) ', value: 'avocat' },
        { label: 'Juriste', value: 'juriste' },
        { label: 'Assistant(e) juridique', value: 'assistant_juridique' },
        { label: 'Autre fonction', value: 'NR' },
    ],
    finances_comptabilite: [
        { label: 'DAF, RAF', value: 'daf' },
        { label: 'Responsable financier', value: 'dir_resp_financier' },
        { label: 'Responsable fiscalité', value: 'dir_resp_fiscalite' },
        { label: 'Expert(e)-comptable', value: 'expert_comptable' },
        { label: 'Commissaire aux comptes', value: 'commissaire_comptes' },
        { label: 'Contrôleur(se) de gestion', value: 'controleur_gestion' },
        { label: 'Comptable', value: 'comptable' },
        { label: 'Assistant(e) comptable', value: 'assistant_comptable' },
        { label: 'Autre fonction', value: 'NR' },
    ],
    rh_formation: [
        { label: 'DRH', value: 'drh' },
        { label: 'RRH', value: 'rrh' },
        { label: 'Responsable du personnel', value: 'dir_resp_personnel' },
        { label: 'Responsable paie', value: 'dir_resp_paie' },
        { label: 'Responsable formation', value: 'dir_resp_formation' },
        { label: 'Responsable du recrutement', value: 'dir_resp_recrutement' },
        { label: 'Assistant(e) RH', value: 'assistant_rh' },
        { label: 'Assistant(e) Formation', value: 'assistant_formation' },
        { label: 'Autre fonction', value: 'NR' },
    ],
    sst: [
        { label: 'Responsable sécurité au travail', value: 'dir_resp_securite_travail' },
        { label: 'Responsable HSE', value: 'dir_resp_hse' },
        { label: 'Responsable prévention', value: 'dir_resp_prevention' },
        { label: 'Assistant(e) HSE', value: 'assistant_hse' },
        { label: 'Préventeur', value: 'preventeur' },
        { label: 'Correspondant(e) sécurité', value: 'correspondant_securite' },
        { label: 'Ingénieur ou technicien(ne) QHSE', value: 'ingenieur_technicien_qhse' },
        { label: 'Ergonome du travail', value: 'ergonome_travail' },
        { label: 'Médecin du travail', value: 'medecin_travail' },
        { label: 'Infirmier(ère) du travail', value: 'infirmier_travail' },
        { label: 'Autre fonction', value: 'NR' },
    ],
};

export const MANDAT = [
    { label: 'CSE - secrétaire', value: 'cse_secretaire' },
    { label: 'CSE - trésorier', value: 'cse_tresorier' },
    { label: 'CSE - membre', value: 'cse_membre' },
    { label: 'Délégué(e) syndical(e)', value: 'ds' },
    { label: 'Aucun mandat', value: 'NR' },
];


export interface Field {
    type: string;
    label: string;
    mandatory: boolean;
    custom: boolean;
    key?: string;
    values?: [{ label: string; value: string }];
    props?: any[];
    default?: string;
    fetch?: boolean;
    validator: string,
    minLength?: number,
    maxLength?: number
}

export interface UserData {
    customFields: any;
    emailVerified?: boolean;
    liteOnly?: boolean;
    email?: string;
}

// same in ReachFiveManagementServiceInterface
export const UNKNOWN = 'unknown';
export const FULL = 'full';
export const LITE = 'lite';

export const REACHFIVE_FIELDS = [
    'given_name',
    'family_name',
    'custom_fields.raison_sociale',
    'custom_fields.telephone_standard',
    'custom_fields.service',
    'custom_fields.mandat',
    'consents'
];

export const getCurrentDate = () => {
    const date = new Date();
    return (
        date.getFullYear() +
        '-' +
        ('0' + (date.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + date.getDate()).slice(-2)
    );
};
export const getFieldConfig = (fieldName: string): Field => {
    // @ts-ignore
    if(fieldName.indexOf('.')>0){
        fieldName = fieldName.substring(fieldName.indexOf('.')+1)
    }

    // @ts-ignore
    return config['fields'][fieldName];
};

export const validateField = (fieldName: string, value: any): boolean => {
    const conf = getFieldConfig(fieldName);
    switch (conf.validator) {
        case 'text':
            const t = typeof value === 'string';
            const min = conf.minLength !== undefined && value && value.length >= conf.minLength;
            const max = conf.maxLength !== undefined && value && value.length <= conf.maxLength;
            return t && min && max;
        case 'phone':
            return typeof value === 'string' && !checkInvalidPhone(value);
        case 'boolean':
            return true;
        case 'select':
            return value && value.value && typeof value.value === 'string' && value.value.length > 0;
        default:
            throw new Error('Not implemented validator ' + conf.validator);
    }
};

export const getFieldValue = (fieldName: string, value: any): any => {
    const conf = getFieldConfig(fieldName);
    switch (conf.validator) {
        case 'boolean':
            if (value === undefined) { return false }
            return value;
        case 'select':
            return value.value;
    }
    return value;
};

export const setCookie = (key: string, value: string, expire?: number): void => {
    const date = new Date();
    date.setTime(date.getTime() + (expire !== undefined ? expire : 60 * 60 * 24 * 365 * 1000));
    const domain = window.location.host.split('.');
    const cookieDomain = domain.length >= 2 ? '; domain=.'+domain[domain.length - 2]+'.'+domain[domain.length - 1] : '';

    document.cookie = key + '=' + value + '; expires=' + date.toUTCString() + '; path=/' + cookieDomain;
};

export const getCookie = (key: string): string => {
    const nameEQ = key + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) {
            document.cookie = key + '=; Max-Age=-99999999;';
            return c.substring(nameEQ.length, c.length);
        }

    }
    return '';
};

export const emailRegEx =
  /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const checkInvalidPhone = (phone: string): boolean => {
    if (phone.indexOf('+33') !== -1) {
        return (!phone.startsWith('+33(0)') || phone.startsWith('+33(0)0') || phone.replace(/\s/g, '').length < 15)
    }

    return false;
};
